/**
 * Polls: the history of polls a member answered and the aggregated results of
 * one, with the member's own answers marked.
 *
 * Answering a poll is a survey, so the form and the submit stay in
 * `features/surveys`; the survey screen composes this feature to show results
 * after a submit. The results fetch is imported by the screens under `app/`
 * directly, until they read it through a hook.
 *
 * The history formatters are the `/model` entry.
 */
export { SurveyResults } from './ui/SurveyResults';
export { usePollHistory } from './hooks/usePollHistory';
export {
  getMyPollResponsesV2QueryOptions,
  getSurveyResultsQueryOptions,
  isSurveyResultsNotFoundError,
} from './api/pollResults';
